import React from "react";
import { Route, Routes } from "react-router-dom";

import ChallengeDetailPage from "~/modules/Challenges/ChallengeDetailPage";
import ChallengeFeedPage from "~/modules/Challenges/ChallengeFeedPage";
import ChallengesListPage from "~/modules/Challenges/ChallengesListPage";

const ChallengesRouter = (): React.ReactElement => {
  return (
    <Routes>
      <Route index element={<ChallengesListPage />} />
      <Route path="/:id" element={<ChallengeDetailPage />} />
      {/* TRE-1655 — the board is its own page, not a tab: it is a place the trainer works in. */}
      <Route path="/:id/tablica" element={<ChallengeFeedPage />} />
    </Routes>
  );
};

export default ChallengesRouter;
